<template>
    <ContentWrapper class="py-12 text-center">
        <div class="text-3xl font-headings">Badge Editor</div>

        <div class="py-8 max-w-2xl mx-auto">
            Easy to use. Badge Sizes, including butterfly and double sided. Pre-print or on demand. Conditional rules
            for colours and visiblity.
        </div>

        <div class="w-full aspect-video relative">
            <DeviceWrapper device-type="laptop" :imageSrc="badgeEditor1" :width="90" />
        </div>

    </ContentWrapper>
</template>
<script setup>
import ContentWrapper from '../../Layouts/ContentWrapper.vue';
import DeviceWrapper from '../../DeviceWrapper.vue';

import badgeEditor1 from '@/images/screenshots/cms/badge-builder.png';

</script>